(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsBurgerOnly = this.getAttribute('data-sticky-type') === 'burger-only';
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size' ||
        this.headerIsBurgerOnly;
      this.headerBounds = {};
      this.mobileStickyMq = window.matchMedia('(max-width: 989px)');

      this.setHeaderHeight();

      var headerHeightMq = window.matchMedia('(max-width: 1023px)');
      if (typeof headerHeightMq.addEventListener === 'function') {
        headerHeightMq.addEventListener('change', this.setHeaderHeight.bind(this));
      } else if (typeof headerHeightMq.addListener === 'function') {
        headerHeightMq.addListener(this.setHeaderHeight.bind(this));
      }

      this.onStickyMqChange = this.syncStickyMode.bind(this);
      if (typeof this.mobileStickyMq.addEventListener === 'function') {
        this.mobileStickyMq.addEventListener('change', this.onStickyMqChange);
      } else if (typeof this.mobileStickyMq.addListener === 'function') {
        this.mobileStickyMq.addListener(this.onStickyMqChange);
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
      this.syncStickyMode();
      this.captureBurgerRestSoon();
    }

    isMobileStickyViewport() {
      if (this.mobileStickyMq) return this.mobileStickyMq.matches;
      return window.innerWidth <= 989;
    }

    getHeaderDrawer() {
      return this.querySelector('header-drawer') || document.querySelector('header-drawer');
    }

    pinBurgerOnly(stickyBar) {
      const drawer = this.getHeaderDrawer();
      if (drawer && typeof drawer.pinToViewport === 'function') {
        drawer.pinToViewport({ stickyBar: Boolean(stickyBar), keepPinned: true });
      }
    }

    unpinBurgerOnly(force) {
      const drawer = this.getHeaderDrawer();
      if (drawer && typeof drawer.unpinFromViewport === 'function') {
        drawer.unpinFromViewport({ force: Boolean(force) });
      }
    }

    captureBurgerRestSoon() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const drawer = this.getHeaderDrawer();
          if (!drawer) return;
          if (typeof drawer.captureStickyPosition === 'function') {
            drawer.captureStickyPosition();
          }
          if (this.headerIsBurgerOnly && this.isMobileStickyViewport()) {
            const scrolled = (window.pageYOffset || document.documentElement.scrollTop) > 1;
            this.pinBurgerOnly(scrolled);
            if (this.header) {
              this.header.classList.toggle('scrolled-past-header', scrolled);
            }
          }
        });
      });
    }

    syncStickyMode() {
      if (!this.header) return;
      if (!this.isMobileStickyViewport()) {
        this.header.classList.remove(
          'shopify-section-header-sticky',
          'header-sticky-burger-only',
          'shopify-section-header-hidden',
          'scrolled-past-header',
          'animate'
        );
        this.unpinBurgerOnly(true);
        return;
      }
      if (this.headerIsBurgerOnly) {
        this.header.classList.add('header-sticky-burger-only');
        this.header.classList.remove('shopify-section-header-sticky');
        this.captureBurgerRestSoon();
        return;
      }
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('header-sticky-burger-only');
        this.unpinBurgerOnly(true);
        return;
      }
      this.header.classList.remove(
        'shopify-section-header-sticky',
        'header-sticky-burger-only',
        'shopify-section-header-hidden',
        'scrolled-past-header',
        'animate'
      );
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.mobileStickyMq && this.onStickyMqChange) {
        if (typeof this.mobileStickyMq.removeEventListener === 'function') {
          this.mobileStickyMq.removeEventListener('change', this.onStickyMqChange);
        } else if (typeof this.mobileStickyMq.removeListener === 'function') {
          this.mobileStickyMq.removeListener(this.onStickyMqChange);
        }
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.headerIsBurgerOnly) {
        if (!this.isMobileStickyViewport()) {
          this.unpinBurgerOnly(true);
          return;
        }
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const drawer = this.getHeaderDrawer();
        if (scrollTop <= 1) {
          this.header.classList.remove('scrolled-past-header');
          if (drawer && typeof drawer.setStickyBar === 'function') {
            drawer.setStickyBar(false);
          }
        } else {
          this.header.classList.add('scrolled-past-header');
          this.pinBurgerOnly(true);
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.headerIsAlwaysSticky && !this.isMobileStickyViewport()) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || !this.isMobileStickyViewport()) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.isMobileStickyViewport()) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || !this.isMobileStickyViewport()) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
